import { useParams } from "@tanstack/react-router";
import de from "$/modules/i18n/asset/messages/de.json";
import en from "$/modules/i18n/asset/messages/en.json";
import { Spinner } from "$/modules/shared/ui/spinner";

export const RoutePending = () => {
	const { locale } = useParams({ strict: false });
	const messages = locale === "en" ? en : de;

	return (
		<div className="grid min-h-[60vh] place-items-center" role="status">
			<Spinner aria-label={messages.common.loading} />
		</div>
	);
};
